import GridColumn from "@/classes/component-classes/GridColumn";
import {ViewShipment} from "@/classes/viewmodels/ViewShipment";

export default class Shipments {
    constructor() {

        this.modes = {

            select: '+/-',
            air: 'Air',
            road: 'Road',
            sea: 'Sea',
            rail: 'Rail',
            courier: 'Courier',
            other: 'Other'
        }

        this.shipmentGridCurrentPage = {

            air: 1,
            road: 1,
            sea: 1,
            rail: 1,
            courier: 1,
            other: 1
        }

        this.shipmentGridCurrentPaginationPage = {

            air: 1,
            road: 1,
            sea: 1,
            rail: 1,
            courier: 1,
            other: 1
        }

        this.shipmentsData = {

            air: [],
            road: [],
            sea: [],
            rail: [],
            courier: [],
            other: []

        }

        this.activeShipmentTabs = {

            air: {name: 'Air', active: true},
            road:{name: 'Road', active: true},
            sea: {name: 'Sea', active: true},
            rail: {name: 'Rail', active: true},
            courier: {name: 'Courier', active: true},
            other: {name: 'Other', active: true},

        }

        this.shipmentDocs = [];
        this.shipmentDocsDrawer = false;
        this.selectedShowShipmentsTab = '';
        this.currentDefaultTab = '';
        this.currentModeDataLength = null;
        this.showingShipmentSearchData = false;
        this.shipmentsSearchTerm = '';
        this.selectedViewShipmentTab = 'Milestones';
        this.warehousePicksModal = false;
        this.showShipmentsDataFilterType = 'All';
        this.showShipmentsHideCompleted = false;
        this.currentPaginationRange = 1;
        this.hideExcelDownloadBusy = true;
        this.openConsolDrawer = false;
        this.files = [];

        this.isConsolJobView = false;
        this.currentConsolJob = {};

        this.viewShipment = new ViewShipment(); //allows ability to new up and empty the screen, on data load error

        // End View Shipment Data

        this.milestoneColumns = [
            new GridColumn('1', 'Date / Time', 'dateTime', '150', true),
            new GridColumn('2', 'Milestone', 'milestone', '440', true),
            new GridColumn('3', 'Comments', 'comments', '560', true),

        ],

        this.collectionDelivery = {

            gridColumns: [

                new GridColumn('1','Note Type', 'noteType', '90', true),
                new GridColumn('2','Cust Ref', 'customerRef', '140', true, false, 20),
                new GridColumn('3','Delivery', 'deliveryDate', '70', true),
                new GridColumn('4','Booking Ref', 'bookingRef', '140', true),
                new GridColumn('5','Company', 'company', '200', true, false, 24),
                new GridColumn('6','Pieces', 'nop', '50', true),
                new GridColumn('7','Weight', 'weight', '70', true)    ,
                new GridColumn('8','Description', 'description', '240', true, false, 45),
                new GridColumn('9','Marks & Numbers', 'marksAndNumbers', '240', true, false, 35),
                new GridColumn('10','Pod Name', 'podName', '100', true, false, 20),
                new GridColumn('11','Pod Date', 'podDate', '70', true),
                new GridColumn('12','Status', 'statusMilestone', '100', false, false, 12),

            ]
        }

        this.containers = {

            gridColumns: [
                new GridColumn('3','Tracking', 'tracking', '78', true),
                new GridColumn('4','Macropoint', 'macropoint', '80', true),
                new GridColumn('1','Number - Type', 'container', '110', true),
                new GridColumn('2','Seal Number', 'sealNumber', '100', true),
                new GridColumn('4','Goods Description', 'description', '200', true, false, 50),
                new GridColumn('6','Pieces', 'pieces', '35', true),
                new GridColumn('7','Gross Weight', 'grossWeight', '80', true),
                new GridColumn('8','Cube', 'cube', '50', true, false, 45),
                new GridColumn('9','Release Ref', 'releaseRef', '140', true, false, 35),
                new GridColumn('10','Release Date', 'depotDate', '80', true, false, 9),
                new GridColumn('11','Reference', 'reference', '180', true),
                new GridColumn('12','Loading Date', 'deliveryDate', '80', true, true, 12),
                new GridColumn('13','Loading Time', 'loadingTime', '70', true, true, 12),

            ],

        }

        this.customs = {

            gridColumns: [

                new GridColumn('1','Entry Number / MRN ', 'mrn', '450', true, false, 60),
                new GridColumn('2','Entry Date', 'entryDate', '300', true, true, 10),
                new GridColumn('3','Cleared Customs', 'customsClearance', '400', true, true, 10),
            ]
        }

        this.warehouseShipmentDetail = {

            gridColumns: [
                new GridColumn('1', '', 'viewPick', '78', true, false ),
                new GridColumn('2', '', 'moreDetail', '78', true, true ),
                new GridColumn('3', 'Warehouse Ref', 'warehouseRef', '230', true, false, 30),
                new GridColumn('5', 'Supplier', 'supplier', '220', true, true, 50),
                new GridColumn('6', 'Customer Ref', 'customerRef', '230', true, false, 40),
                new GridColumn('7', 'Items', 'pieces', '80', true, true, 10),
                new GridColumn('8', 'Gross Weight', 'grossWeight', '100', true, true, 10),
                new GridColumn('4', 'Cube', 'cube', '80', true, true, 10),

            ],

        }


        this.warehousePicks = {

            gridColumns: [

                new GridColumn('1', 'SKU Group', 'skuGroup', '240', true, false, 50),
                new GridColumn('2', 'SKU Number', 'skuNumber', '180', true, true, 10),
                new GridColumn('3', 'SKU Name', 'skuName', '285', true, true, 10),
                new GridColumn('4', 'Comments', 'skuComments', '310', true, false, 40),
                new GridColumn('5', 'Quantity', 'quantity', '50', true, true, 10),
                new GridColumn('6', 'Group Headings (Hover For More Details)', 'skuProperties', '420', true, true, 10),

            ],

            selectedShipmentItem: {},

            dummyData: [
                {
                    id: '1',
                    skuGroup: 'Technical Balls',
                    skuNumber: '12226343',
                    skuName: 'Bouncy Items',
                    quantity: '23',
                    comments: 'Comments',

                    skuProperties: {
                        descOne: {
                            heading: 'Some Large Desc Heading',
                            value: '34'
                        },
                        descTwo: {
                            heading: 'Color',
                            value: 'Red'
                        },
                        descThree: {
                            heading: 'Lot Number',
                            value: '4LOT55789'
                        },
                        descFour: {
                            heading: 'Alfa Bazzarre',
                            value: 'POYY6654RRE4789'
                        },
                        descFive: {
                            heading: 'Teeth Maluversion Compound',
                            value: 'Chemical pollution stats'
                        },
                        descSix: {
                            heading: 'Other',
                            value: 'Fat Boy Slim'
                        },

                        skuDescription: 'Whatever you want',

                    }
                },

                {
                    id: '2',
                    skuGroup: 'Technical Balls',
                    skuNumber: 'LOTeAA3',
                    skuName: 'Bouncy Items',
                    skuDescription: 'Whatever you want',
                    quantity: '12',
                    comments: 'Comments',

                    skuProperties: {
                        descOne: {
                            heading: 'Lot Number',
                            value: ''
                        },
                        descTwo: {
                            heading: 'Bar Code',
                            value: ''
                        },
                        descThree: {
                            heading: 'Size',
                            value: 'Large'
                        },
                        descFour: {
                            heading: 'Lot Number',
                            value: '4LOT55789'
                        },
                        descFive: {
                            heading: 'Teeth Maluversion Compound',
                            value: 'Chemical pollution stats'
                        },
                        descSix: {
                            heading: 'Best Before',
                            value: '31-Jan-24'
                        },

                        skuDescription: 'Lorem Ipsum is simply dummy text of the printing and typesetting industry.' +
                            'and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.',
                    }
                },

                {
                    id: '2',
                    skuGroup: 'Technical Balls',
                    skuNumber: 'AASSSS6343',
                    skuName: 'Bouncy Items',
                    quantity: '6',
                    comments: 'Comments',
                    skuProperties: {
                        descOne: {
                            heading: 'Size',
                            value: 'medium'
                        },
                        descTwo: {
                            heading: 'Collar Type',
                            value: 'Massive'
                        },
                        descThree: {
                            heading: 'Size',
                            value: 'Small'
                        },
                        descFour: {
                            heading: 'Lot Number',
                            value: '4LOT55789'
                        },
                        descFive: {
                            heading: 'Teeth Maluversion Compound',
                            value: 'Chemical pollution stats'
                        },
                        descSix: {
                            heading: 'Other',
                            value: 'Fat Boy Slim'
                        },

                        skuDescription: 'Whatever you want',
                    }
                }
            ]

        }


        this.shipmentErrorLogs = [];

           this.consolGridColumns = [

               new GridColumn('1','Details', 'selectRow', '78', true,true),
               new GridColumn('2','Shipment Number', 'jobNumber', '120', true),
               new GridColumn('3','Origin', 'shipperName', '200', true),
               new GridColumn('4','Destination', 'consigneeName', '200', true, false, 24),
               new GridColumn('5','Shipper Ref', 'shipperRef', '160', true),
               new GridColumn('6','Consignee Ref', 'consigneeRef', '160', true),
               new GridColumn('7','Mode', 'mode', '60', true),

           ]

        this.consolGridData = [];
        this.currentSelectedConsolJob = {shipmentRef: ""};

    }

}
